// Libs
import { useRouter } from 'next/router';
import { useState, useEffect, ReactElement } from 'react';
// App
import styles from './route-loading.module.scss';
import { Spinner } from 'ui-components';

const RouteLoading = (): ReactElement => {
  const router = useRouter();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => setLoading(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  });

  return (
    loading && (
      <div className={styles.spinnerContainer}>
        <Spinner className={styles.spinner} color="contrast" />
      </div>
    )
  );
};

export default RouteLoading;
